module.exports = new Promise(function (resolve, reject) {
    if (window['driveWeb']) {
      resolve(window['driveWeb']);
      return;
    }

    var appEnv = (window.__env__ && window.__env__['sivBillingAttachmentWeb']) || {};
    var host = appEnv['DRIVE_WEB_HOST'] || "";

    if (!host) {
      reject(new Error('Missing remote host: DRIVE_WEB_HOST'));
      return;
    }

    var src = host.replace(/\/$/, '') + '/remoteEntry.js';
    var existingScript = document.querySelector('script[data-webpack-runtime-remote="driveWeb"]');

    if (existingScript) {
      existingScript.addEventListener('load', function () {
        resolve(window['driveWeb']);
      });
      existingScript.addEventListener('error', function () {
        reject(new Error('Failed to load driveWeb'));
      });
      return;
    }

    var script = document.createElement('script');
    script.src = src;
    script.dataset.webpackRuntimeRemote = 'driveWeb';
    script.onload = function () {
      resolve(window['driveWeb']);
    };
    script.onerror = function () {
      reject(new Error('Failed to load driveWeb'));
    };
    document.head.appendChild(script);
  });